import { call, put, takeEvery, select, takeLeading } from 'redux-saga/effects'
import {
  types,
  ICreateDatafileAction,
  IGetDataFileAction,
  IUpdateDatafileAction,
  IMultipleDataStreamForPreviewRequest,
} from '../types/datafile'
import { push } from '../actions/router'
import * as actions from '../actions/datafile'
import * as packActions from '../actions/pack'
import * as packSelectors from '../selectors/pack'
import * as services from '../services/datafile'
import * as fileServices from '../services/file'
import { trace } from '../services/common'
import { messages } from '../config/messages'

export function* createDatafileSaga(action: ICreateDatafileAction) {
  try {
    const datastream = yield call(
      services.createDataFile,
      action.packId,
      action.datastream
    )
    yield put(
      actions.createDatafileSuccess(
        messages.createEditionForFileCreateSuccess(
          fileServices.formatFileName(datastream.dataStreamData.fileName)
        )
      )
    )
    yield put(packActions.getPackById(action.packId))
    const groupId = yield select(packSelectors.selectParentGroup)
    yield put(
      push(
        `/group/${groupId}/pack/${action.packId}?edition=${datastream.id}&tab=publish`
      )
    )
  } catch (err) {
    trace(err)
    yield put(actions.createDatafileFailure(err.message, err.correlationId))
  }
}

export function* getDataFileSaga(action: IGetDataFileAction) {
  try {
    const isDataBundleRequest = !!(action.datastream as IMultipleDataStreamForPreviewRequest)
      .DataRequests
    const datastream = yield call(
      isDataBundleRequest ? services.getDataBundle : services.getDataFile,
      action.datastream
    )
    yield put(actions.getDataFileSuccess(datastream))
  } catch (err) {
    trace(err)
    yield put(actions.getDataFileFailure(err.message))
  }
}

export function* updateDatafileSaga(action: IUpdateDatafileAction) {
  try {
    const edition = yield select(packSelectors.selectEdition(action.editionId))
    const datastream = yield call(
      services.updateDataFile,
      action.packId,
      action.editionId,
      // TODO: investigate whether we can avoid merging the edition and the action.datastream @Andrew, @BE
      { ...edition, slugline: edition.slugline || '', ...action.datastream }
    )
    yield put(
      actions.updateDatafileSuccess(
        messages.createEditionForFileUpdateSuccess(
          fileServices.formatFileName(datastream.dataStreamData.fileName)
        )
      )
    )
    yield put(packActions.getPackById(action.packId))
    const groupId = yield select(packSelectors.selectParentGroup)
    yield put(
      push(
        `/group/${groupId}/pack/${action.packId}?edition=overall-pack&tab=details`
      )
    )
  } catch (err) {
    trace(err)
    yield put(actions.updateDatafileFailure(err.message, err.correlationId))
  }
}

export function* datafileWatcher() {
  yield takeLeading(types.CREATE_DATAFILE__STARTED, createDatafileSaga)
  yield takeEvery(types.GET_DATAFILE__STARTED, getDataFileSaga)
  yield takeLeading(types.UPDATE_DATAFILE__STARTED, updateDatafileSaga)
}
